var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceD8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 247.375 508.718 238.75 502.155 232.125L279.878 9.875C273.252 3.25 264.626 0 256 0S238.748 3.25 232.122 9.875L9.845 232.125C3.282 238.75 0 247.406 0 256.047C0 264.688 3.282 273.312 9.845 279.875L232.122 502.125C238.748 508.75 247.374 512 256 512S273.252 508.75 279.878 502.125L502.155 279.875C508.718 273.25 512 264.625 512 256ZM280.003 77.875L446.398 244.25L280.003 315.625V77.875ZM231.997 315.625L65.602 244.25L231.997 77.875V315.625ZM231.997 367.875V434.125L115.983 318.125L231.997 367.875ZM280.003 367.875L396.017 318.125L280.003 434.125V367.875Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceD8);
export default __webpack_public_path__ + "static/media/dice-d8.18f45cc308a80df5373bf631a61883f5.svg";
export { ForwardRef as ReactComponent };